import NavBar from "../navbar/NavBar.js"

export default function Header () {
  return (
    <header>
      <NavBar/>
    </header>
  )
}
